import { Component, Input, OnInit } from '@angular/core';
import { CommonAuthService } from '@libs/common-services';
import { ApiService, UserType } from '@libs/apis';
import { FeatureConfigResponseDTO } from '@libs/api';

interface UserDetails {
  userType?: string;
  type?: string;
}

@Component({
  selector: 'lib-ui-alpha-feature-enabler',
  templateUrl: './alpha-feature-enabler.component.html',
  styleUrl: './alpha-feature-enabler.component.scss'
})
export class AlphaFeatureEnablerComponent implements OnInit {
  @Input() userDetails?: UserDetails; // Optional input for custom user details
  @Input() clientId?: number;
  @Input() brandId?: number;

  public isAiFeatureEnabled: boolean | null = null;

  constructor(
    private readonly authService: CommonAuthService,
    private readonly apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.extractUserType();
  }

  private async extractUserType(): Promise<void> {
    try {
      let userType: string;

      if (this.userDetails) {
        userType = this.userDetails.userType || this.userDetails.type || '';
      } else {
        const user = this.authService.getUser();
        userType = user?.getUserType() || '';
      }
      this.isAiFeatureEnabled =
        userType === UserType.internal || (await this.checkAiFeatureEnabled());
    } catch (error) {
      console.warn('Error extracting user type:', error);
      this.isAiFeatureEnabled = false; // Default to external/non-internal
    }
  }

  private async checkAiFeatureEnabled(): Promise<boolean> {
    console.log(
      'checkAiFeatureEnabled in alpha feature enabler:',
      this.clientId,
      this.brandId
    );
    if (!this.clientId || !this.brandId) {
      return false;
    }
    try {
      const featureConfig =
        await this.apiService.platformApisOperations.getAllFeatureConfigs(
          this.clientId,
          this.brandId
        );
      const isAiFeatureEnabled = featureConfig.some(
        (feature) =>
          feature.featureName ===
            FeatureConfigResponseDTO.FeatureNameEnum.AiTaxonomy &&
          feature.visibility ===
            FeatureConfigResponseDTO.VisibilityEnum.AllUsers
      );
      return isAiFeatureEnabled;
    } catch (error) {
      console.warn('Error getting feature config:', error);
      return false;
    }
  }
}
